import React from 'react';
import { CheckLineIcon } from '@svg/CheckLineIcon';

const steps = [
  {
    id: 1,
    title: 'Check Existing Contractor',
    description:
      'Search for contractor by Tax Identification Number (TIN) to avoid duplicates.',
  },
  {
    id: 2,
    title: 'Review Existing Contractor',
    description: 'Review contractor details if a match is found.',
  },
  {
    id: 3,
    title: 'Enter Contractor Info',
    description: 'Provide contractor information and business details.',
  },
  {
    id: 4,
    title: 'Confirm Level of Service',
    description: 'Select and confirm the level of service for this contractor.',
  },
  {
    id: 5,
    title: 'Finish',
    description:
      'Search for contractor by Tax Identification Number (TIN) to avoid duplicates.',
  },
];

type ContractorFlowStepsProps = {
  currentStep?: number;
  hideReviewStep?: boolean;
};

export const ContractorFlowSteps = ({
  currentStep = 1,
  hideReviewStep = false,
}: ContractorFlowStepsProps) => {
  const visibleSteps = hideReviewStep
    ? steps.filter((step) => step.id !== 2)
    : steps;

  return (
    <div
      className="contractor-flow__steps"
      aria-label="Contractor creation progress"
    >
      {visibleSteps.map((step, index) => {
        const isComplete = step.id < currentStep;

        return (
          <div
            className={`contractor-flow__step ${step.id === currentStep ? 'is-active' : ''} ${isComplete ? 'is-complete' : ''}`}
            key={step.id}
          >
            <div className="contractor-flow__step-track">
              <span className="contractor-flow__step-number">
                {isComplete ? <CheckLineIcon aria-hidden="true" /> : index + 1}
              </span>
              {index < visibleSteps.length - 1 && (
                <span className="contractor-flow__step-line">
                  <span
                    className="contractor-flow__step-line-progress"
                    aria-hidden="true"
                  />
                </span>
              )}
            </div>
            <div className="contractor-flow__step-copy">
              <h2>{step.title}</h2>
              <p>{step.description}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
